// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--G7fGl","border":"a10a3f92e9--border--ZWdFN","title":"a10a3f92e9--title--l6I3W","list":"a10a3f92e9--list--XWtJC"};